require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-does-it-mean-for-the-world-bank-to-take-a-stand.json") })
        }
      }, "path---en-us-update-what-does-it-mean-for-the-world-bank-to-take-a-stand");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-does-it-mean-for-the-world-bank-to-take-a-stand!./.cache/json/en-us-update-what-does-it-mean-for-the-world-bank-to-take-a-stand.json
// module id = 835
// module chunks = 231608221292675